module.exports = __webpack_public_path__ + "static/media/community-verticals.182d9a96.svg";